export const MEDIA_BREAK_POINT = {
  SM: 640,
  MD: 768,
  LG: 1024,
  XL: 1260,
};

export const SMARTPHONE = 'smartphone';
export const PC = 'pc';
